import { memo } from 'react';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { TableColumnsFilter } from 'common/ColumnsFilter/ColumnsFilter';
import { FilterButton } from 'common/FilterButton/FilterButton';
import type { MunicipalitiesTableControlsProps } from './types';
import styles from './Controls.module.scss';

export const MunicipalitiesTableControls = memo<MunicipalitiesTableControlsProps>((props) => {
  return (
    <AppFlex direction="row" justifyContent="flex-end" className={styles.controls}>
      <AppButton onClick={props.createMunicipality}>Создать муниципалитет</AppButton>
      <FilterButton count={props.filterCount} click={props.showSider} />
      <TableColumnsFilter
        visibleKeys={props.visibleKeys}
        columns={props.columns}
        setVisibleKeys={props.setVisibleKeys}
      />
    </AppFlex>
  );
});
